var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('Hero',{attrs:{"heading":"Thank you","subheading":true},scopedSlots:_vm._u([{key:"subheading",fn:function(){return [_c('p',[_vm._v("Your information has been received.")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }